import { render, staticRenderFns } from "./JouezOld.vue?vue&type=template&id=e73510c6&"
import script from "./JouezOld.vue?vue&type=script&lang=js&"
export * from "./JouezOld.vue?vue&type=script&lang=js&"
import style0 from "./JouezOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports